import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable()
export class AdminService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  registerUser(user: any): Observable<any> {
    const REST_URL = `${this.baseUrl()}/users/${user.username}`;
    return this.http.post(REST_URL, user);
  }

  updateUser(user: any): Observable<any> {
    const REST_URL = `${this.baseUrl()}/users/${user.username}`;
    return this.http.put(REST_URL, user);
  }

  resetPassword({ username }: any): Observable<any> {
    const REST_URL = `${this.baseUrl()}/auth/adminResetPassword`;
    return this.http.post(REST_URL, { username });
  }

  private baseUrl(): string {
    return this.configService.apiUrl();
  }
}
